/**
 * Доступность клея внутри МСК Газобетона.
 *
 * Признак ровно один: у конкретного клея есть цена в основной таблице, откуда уже
 * приходят цены товаров (`price_cash` / `price_non_cash` строки каталога по текущей
 * форме оплаты). Летний и зимний клей ничем другим не различаются:
 *
 * - цена есть — клей доступен для выбора и расчёта;
 * - цены нет — добавить нельзя, вместо стоимости стоит «Цена по запросу»;
 * - цены на оба — доступны оба; цена на один — доступен только он.
 *
 * Сезон по дате здесь не определяется, чужая, прошлая и резервная цена не
 * подставляются: доступность целиком решает то, принёс ли загрузчик цен цену
 * именно на эту позицию. Своих цен и названий модуль не содержит.
 *
 * Вне области правило не применяется — за это отвечает признак
 * `isMskGazobetonScope`, который приходит готовым и здесь не пересчитывается.
 */

import { hasUsablePrice } from './gazUpsellMetrics.js';
import { priceOf } from './gazUpsellSelection.js';

/** Подпись вместо стоимости у позиции, цены на которую источник не принёс. */
export const GAZ_PRICE_ON_REQUEST = 'Цена по запросу';

/** Строка каталога — клей. Категория берётся из номенклатуры как есть. */
export const isGlueItem = (item) => String(item?.category || '')
  .trim()
  .toLowerCase() === 'клей';

/**
 * Клей доступен: источник принёс цену по текущей форме оплаты.
 * Ноль, пустое значение и мусор ценой не считаются (см. `hasUsablePrice`).
 */
export const isGlueAvailable = (item, paymentMethod) => hasUsablePrice(priceOf(item, paymentMethod));

/**
 * Позицию нельзя добавить и вместо стоимости показывается «Цена по запросу».
 * Правило действует только внутри области и только для клея — остальные категории
 * и всё, что вне МСК Газобетона, ведут себя как прежде.
 */
export const isGluePriceOnRequest = ({ item, paymentMethod, isMskGazobetonScope } = {}) => Boolean(
  isMskGazobetonScope && isGlueItem(item) && !isGlueAvailable(item, paymentMethod)
);

export default isGluePriceOnRequest;
